import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Input, TextErrorInput, Button } from '@provi/provi-components'
import { Form } from '../../../components/form'

export const Formik = props => {
  const { handleChange, values, errors, touched, handleBlur, handleSubmit } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        autoFocus
        margin="normal"
        id="name"
        placeholder="Escreva aqui"
        onChange={handleChange('personalSupportDecision')}
        onBlur={handleBlur('personalSupportDecision')}
        error={!!errors.personalSupportDecision}
        value={values.personalSupportDecision}
      />
      {errors.personalSupportDecision && touched.personalSupportDecision && (
        <TextErrorInput text={errors.personalSupportDecision} />
      )}

      <Button
        marginHorizontal={0}
        type="submit"
        disabled={errors.personalSupportDecision || !values.personalSupportDecision}
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFomik = withFormik({
  validateOnBlur: false,
  validateOnChange: true,
  enableReinitialize: true,
  mapPropsToValues: props => ({ personalSupportDecision: props.data || '' }),
  validationSchema: Yup.object().shape({
    personalSupportDecision: Yup.string()
      .min(5, 'A resposta deve conter no mínimo 5 caracteres')
      .max(2048, 'A resposta deve conter no máximo 2048 caracteres')
      .required('Digite um texto válido')
  }),
  handleSubmit: async ({ personalSupportDecision }, { setSubmitting, props }) => {
    props.goToNextScreen(personalSupportDecision)
    setSubmitting(false)
  }
})(Formik)
